import { buildModelManager } from "../builder.js";
const DefaultWorkItemPhotoSelection = {
  __typename: true,
  id: true,
  caption: true,
  createdAt: true,
  deletedAt: true,
  photo: { url: true, mimeType: true, fileName: true },
  photoType: true,
  photoUrl: true,
  profileId: true,
  updatedAt: true,
  workItemId: true
};
const modelApiIdentifier = "workItemPhoto";
const pluralModelApiIdentifier = "workItemPhotos";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemPhotoSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWorkItemPhoto",
    operationReturnType: "CreateWorkItemPhoto",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      workItemPhoto: { required: false, type: "CreateWorkItemPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWorkItemPhotos",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateWorkItemPhotosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "updateWorkItemPhoto",
    operationReturnType: "UpdateWorkItemPhoto",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItemPhoto: { required: false, type: "UpdateWorkItemPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWorkItemPhotos",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateWorkItemPhotosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "deleteWorkItemPhoto",
    operationReturnType: "DeleteWorkItemPhoto",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWorkItemPhotos",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreWorkItemPhoto",
    operationReturnType: "RestoreWorkItemPhoto",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItemPhoto: { required: false, type: "RestoreWorkItemPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreWorkItemPhotos",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreWorkItemPhotosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "upsertWorkItemPhoto",
    operationReturnType: "UpsertWorkItemPhoto",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      workItemPhoto: { required: false, type: "UpsertWorkItemPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWorkItemPhotoResult": { hasReturnType: false },
      "... on UpdateWorkItemPhotoResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWorkItemPhotos",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertWorkItemPhotosInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWorkItemPhotoSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "workItemPhotoGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WorkItemPhotoManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWorkItemPhotoSelection,
  operations
);
export {
  DefaultWorkItemPhotoSelection,
  WorkItemPhotoManager
};
//# sourceMappingURL=WorkItemPhoto.js.map
